<template>
  <div style="max-width: 600px; min-height: 40vh" class="mx-auto bg-white">
    <div class="d-flex align-items-center flex-column justify-content-center">
      <router-link to="/">
        <b-img
          class="mx-auto mt-1"
          style="height: 100px"
          :src="require('@/assets/images/logo/header-logo.png')"
        />
      </router-link>
      <hr class="w-100" />

      <!--<div class="mt-2">-->
        <!--<p style="text-align: center; line-height: 2.3rem; font-size: 14pt">-->
          <!--نعتذر انتهت فترة التسجيل على الإستمارة        </p>-->
        <!--<div class="d-flex mt-4 justify-content-center">-->
          <!--<b-button to="/" variant="primary" class="mx-auto">-->
            <!--<div class="d-flex justify-content-center align-items-center">-->
              <!--عودة للرئيسية-->
              <!--<feather-icon class="ml-50" icon="ArrowLeftIcon" size="18" />-->
            <!--</div>-->
          <!--</b-button>-->
        <!--</div>-->
      <!--</div>-->
      <router-view />
    </div>
  </div>
</template>

<script>
import { BImg, BButton } from "bootstrap-vue";
export default {
  components: { BImg, BButton },
};
</script>
